import {
    ConditionalLogic,
    FormContext,
    iControlProps,
    iFormControlled
} from "../types";
import { Paragraph, PcaHeading } from "../../theme/typography";
// import React, { useEffect } from "react";
import React, { useEffect, useRef } from "react";

import { replaceMergeTagsInString } from "../helper";

type ButtonProps = {
    text: string;
    conditionalLogic?: ConditionalLogic;
};

type PageProps = iFormControlled &
    iControlProps & {
        type: "page";
        title?: string;
        description?: string;
        nextButton?: ButtonProps;
        previousButton?: ButtonProps;
        hideNext?: boolean;
        hideBack?: boolean;
    };

const getValues = (context?: FormContext) =>
    (context && context.state.values) || {};

export const Page = (props: PageProps) => {
    const { title } = props;
    const hideTitle = props.cssClass
        ? props.cssClass.split(" ").includes("hide-title")
        : false;
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, []);

    return (
        <>
            <div tabIndex={-1} ref={ref} style={{ outline: "none" }}></div>
            {title && !hideTitle && (
                <PcaHeading className={props.cssClass}>
                    {replaceMergeTagsInString(title, getValues(props.context))}
                </PcaHeading>
            )}
            {props.description && <Paragraph>{props.description}</Paragraph>}
        </>
    );
};
Page.defaultProps = {
    type: "page"
};

export default Page;
